import apiConfig from 'http/services/api.config'
import apiService from 'http/services/api.service'
import { ApiResponse } from 'http/types/api-response'
import { CameraModel } from 'domain/camera-model'
import { CameraModelListResponse } from '../types/camera-model-list-response'

class CameraModelApiService {
  private readonly baseUrl: string

  constructor() {
    this.baseUrl = apiConfig.endpoints.cameraModels
  }

  public async getCameraModels(): Promise<CameraModelListResponse> {
    return apiService.get<CameraModelListResponse>(this.baseUrl)
  }

  public async getCameraModelById(id: string): Promise<ApiResponse<CameraModel>> {
    return apiService.get<ApiResponse<CameraModel>>(`${this.baseUrl}/${id}`)
  }
}

export const cameraModelApiService = new CameraModelApiService()
export default cameraModelApiService
